<template>
  <div class="wh100 main" id="mymap">
    <slot></slot>
  </div>
</template>
<script>
import geojson from "../../../../public/geojson.json";
import geojson1 from "../../../../public/geojson1.json";
import river from "../../../../public/river.json";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import "../../../commonJs/map/leaflet-velocity.min.js";
import "../../../commonJs/map/leaflet-velocity.min.css";
import measureTool from "../../../commonJs/map/measure.js";

export default {
  props: {
    channelMap: {
      type: String,
      default: "WaterLevel",
    },
    channelName: {
      type: String,
      default: "水质类别",
    },
    mapChangeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      riverLatLngs: [],
      riverData: [],
      Curtooltip: null,
      //控制不同类型的marker显示隐藏
      markerVisible: {
        dq: true,
        hl: true,
        ws: true,
      },
      //存储不同类型的markergroup图层，用来隐藏和显示
      markerGroup: {
        dq: null,
        hl: null,
        ws: null,
      },
      map: null,
      stationTypeMap: [
        { code: "ST002", key: "dq" },
        { code: "ST003", key: "hl" },
      ],
      riverColor: [
        { level: 0, color: "#acacac" },
        { level: 1, color: "#3cc7f5" },
        { level: 2, color: "#11abf1" },
        { level: 3, color: "#5dd420" },
        { level: 4, color: "#ffc000" },
        { level: 5, color: "#fd8200" },
        { level: 6, color: "#fd3c00" },
      ],
      //风场图层
      windLayer: null,
      //图片图层
      imageOverlay: null,
      //乡镇图层
      townBoundary: null,
      geoStyleHide: {
        color: "#01A8FF",
        weight: 2,
        fill: true,
        fillColor: "#01A8FF",
        fillOpacity: 0.0,
        opacity: 0.0,
      },
      geoStyleShow: {
        color: "#01A8FF",
        weight: 2,
        fill: true,
        fillColor: "#01A8FF",
        fillOpacity: 0.1,
        opacity: 0.4,
      },
      //tvocmarker数据
      markerData: [],
      vocsMarkerData: [],
      //指标分级标准
      channelLevelStandard: null,
      curZoomIndex: 8,
    };
  },
  methods: {
    //初始化地图
    initMap() {
      let map = L.map("mymap", {
        minZoom: 3,
        maxZoom: 16,
        center: [39.1, 115.702331],
        zoom: 8.5,
        zoomControl: false,
        attributionControl: false,
      });
      this.map = map;
      window.map = map;
      L.tileLayer(
        "http://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}"
      ).addTo(map);

      //this.initRiver();
      this.initCityBoundary();
      this.map.on("zoomend", (e) => {
        this.mapZoomed(e);
      });
    },
    //地图放大缩小事件
    mapZoomed(e) {
      this.curZoomIndex = e.target.getZoom();
      let markerSize = this.getMarkerSize();
      this.changeMarker(markerSize);
      /* if (this.curZoomIndex > 13) {
        this.townBoundary.setStyle(this.geoStyleShow);
        this.imageOverlay.setOpacity(0);
      } else {
        this.townBoundary.setStyle(this.geoStyleHide);
        this.imageOverlay.setOpacity(0.8);
      } */
    },
    //切换标注形态
    changeMarker(type) {
      let that = this;
      for (let i = 0; i < that.stationTypeMap.length; i++) {
        const station = that.stationTypeMap[i];
        if (that.markerGroup[station.key]) {
          let group = that.markerGroup[station.key];
          group.eachLayer(function (marker) {
            marker.setIcon(
              that.createStationIcon(station.key, marker.options.extData, type)
            );
          });
        }
      }
    },
    //根据curZoomIndex得到marker的大小
    getMarkerSize() {
      let markerSize = "small";
      if (this.curZoomIndex > 10) {
        markerSize = "divBig";
      } else if (this.curZoomIndex >= 8) {
        markerSize = "big";
      } else if (this.curZoomIndex < 6 && this.curZoomIndex >= 1) {
        markerSize = "small";
      } else if (this.curZoomIndex < 1) {
        markerSize = "divSmall";
      }
      return markerSize;
    },

    initRiver(riverData) {
      let that = this;
      that.riverData = riverData;
      let layerGeo = L.geoJSON(river, {
        style: function (feature) {
          let river = riverData.filter(function (e) {
            return e.RiverName == feature.properties.NAME;
          });
          let color = that.riverColor[0].color; //"#6495ed";
          if (river.length > 0) {
            var data = that.riverColor.filter(function (item) {
              return item.level == river[0].CurWaterLevel;
            });
            if (data.length > 0) color = data[0].color;
          }

          return { color: color, weight: 4 };
        },
        onEachFeature: function (feature, layer) {
          layer.extData = feature;
          layer
            .on("mouseover", that.riverOver)
            .on("mouseout", function (e) {
              e.sourceTarget.unbindTooltip();
            })
            .on("click", that.riverClick);
          let riverLatLng = {
            name: "",
            latlng: [],
          };
          riverLatLng.name = feature.properties.NAME;

          if (feature.geometry.type == "LineString")
            riverLatLng.latlng = feature.geometry.coordinates[0];
          else riverLatLng.latlng = feature.geometry.coordinates[0][0];
          that.riverLatLngs.push(riverLatLng);
        },
      }).addTo(that.map);
    },

    getLevelStr(CurWaterLevel) {
      let waterLevel = "";
      if (CurWaterLevel == 1) waterLevel = "Ⅰ类";
      if (CurWaterLevel == 2) waterLevel = "Ⅱ类";
      if (CurWaterLevel == 3) waterLevel = "Ⅲ类";
      if (CurWaterLevel == 4) waterLevel = "Ⅳ类";
      if (CurWaterLevel == 5) waterLevel = "Ⅴ类";
      if (CurWaterLevel > 5) waterLevel = "劣Ⅴ类";
      return waterLevel;
    },
    riverOver(e) {
      let that = this;
      let riverName = e.sourceTarget.extData.properties.NAME;

      let rivers = that.riverData.filter(function (e) {
        return e.RiverName == riverName;
      });
      let waterLevel = "--";
      if (rivers.length > 0 && rivers[0].CurWaterLevel != null) {
        waterLevel = that.getLevelStr(rivers[0].CurWaterLevel);
      }
      let tooltipStr = "";
      tooltipStr =
        "<div>河流名称：" +
        e.sourceTarget.extData.properties.NAME +
        "</div>" +
        "<p>当前水质：" +
        waterLevel +
        "</p>";
      let offset = [0, 0];

      e.sourceTarget
        .bindTooltip(tooltipStr, {
          direction: "top",
          offset: offset,
          className: "my-map-tooltip",
        })
        .openTooltip(e.latlng);
    },
    riverClick(e) {
      if (this.$listeners["river-click"]) {
        this.$emit("river-click", e.sourceTarget, e.sourceTarget.extData);
      }
    },
    //初始化区域边界
    initCityBoundary() {
      let that = this;
      let myStyle = {
        color: "#0101DF",
        weight: 2,
        fill: true,
        fillColor: "#01A8FF",
        fillOpacity: 0.1,
        opacity: 0.5,
      };
      L.geoJSON(geojson1, myStyle).addTo(that.map);
    },
    markerShow(type) {
      this.markerVisible[type] = !this.markerVisible[type];
      if (this.markerVisible[type]) {
        if (this.markerGroup[type]) {
          this.map.addLayer(this.markerGroup[type]);
        }
      } else {
        if (this.markerGroup[type]) {
          this.map.removeLayer(this.markerGroup[type]);
        }
      }
      return this.markerVisible[type];
    },
    setSewageMarker(SewageMarkerData) {
      let that = this;
      that.markerGroup["ws"] = L.layerGroup(
        that.createStationMarker("ws", SewageMarkerData, true)
      );
      that.map.addLayer(that.markerGroup["ws"]);
    },
    initStationMarker(StationMarkerData) {
      this.markerData = StationMarkerData;
      this.setStationMarker();
    },
    //创建断面的marker
    setStationMarker() {
      let that = this;
      let stationData_dq = that.markerData.filter(function (e) {
        return e.StationType == "淀区" && e.Lat != null && e.Lon != null;
      });
      let stationData_hl = that.markerData.filter(function (e) {
        return e.StationType == "河流" && e.Lat != null && e.Lon != null;
      });
      that.markerGroup["dq"] = L.layerGroup(
        that.createStationMarker("dq", stationData_dq, false)
      );
      that.map.addLayer(that.markerGroup["dq"]);

      that.markerGroup["hl"] = L.layerGroup(
        that.createStationMarker("hl", stationData_hl, false)
      );
      that.map.addLayer(that.markerGroup["hl"]);
    },
    //根据类型创建marker
    createStationMarker(type, data, isWS) {

      let that = this;
      let markers = [];
      let markerSize = that.getMarkerSize();
      data.forEach((item) => {
        item.isWS = isWS;
        let icon = that.createStationIcon(type, item, markerSize);
        let marker = L.marker([item.Lat, item.Lon], {
          icon: icon,
          extData: item,
          type: type,
        });
        marker
          .on("mouseover", that.markerOver)
          .on("mouseout", function (e) {
            e.sourceTarget.unbindTooltip();
          })
          .on("click", that.markerClick);
        markers.push(marker);
      });
      return markers;
    },
    createStationIcon(stationType, item, iconType) {
      let that = this;
      let icon = null;
      let value = item[that.channelMap];
      let isOnline = value != null;
      let imgIndex = "0";
debugger;
      if (!isOnline) {
        imgIndex = "0";
      } else {
        if (item.isWS) imgIndex = "0";
        else
          imgIndex =
            that.channelMap == "WaterLevel" ? value : that.getLevel(value,stationType);
      }
      if (iconType == "divSmall" || iconType === "divBig") {
        icon = that.createDivIcon(item, iconType,stationType);
      } else {
        let imgPath =
          "/map/marker/" +
          iconType +
          "/" +
          stationType +
          "_" +
          imgIndex +
          ".png";
        if (iconType == "small") {
          icon = L.icon({
            iconUrl: imgPath,
            iconSize: [24, 24],
            iconAnchor: [12, 12],
          });
        } else if (iconType == "big") {
          icon = L.icon({
            iconUrl: imgPath,
            iconSize: [32, 32],
            iconAnchor: [16, 16],
          });
        }
      }

      return icon;
    },
    createDivIcon(item, type,stationType) {
      let that = this;
      let value = item[that.channelMap];
      let isOnline = value != null;
      let level = "0";
      if (!isOnline) {
        level = "0";
      } else {
        if (item.isWS) level = "0";
        else
          level =
            that.channelMap == "WaterLevel" ? value : that.getLevel(value,stationType);
      }
      
      let className = "map-marker-level" + level;
      if (type === "divBig") {
        let myHtml =
          "<div class='text-marker-div " +
          className +
          "'>" +
          (value ? (that.channelMap == "WaterLevel" ? this.getLevelStr(value) : value) : "--") +
          "</div>";
        let myIcon = L.divIcon({
          html: myHtml,
          className: "textMarker ",
          // iconSize: 30,
          iconAnchor: [25, 12.5],
        });
        return myIcon;
      } else if (type === "divSmall") {
        let myHtml = "<div class='textMarkerDot " + className + "'></div>";
        let shadowClass = "map-marker-shadow-level" + level;
        let myIcon = L.divIcon({
          html: myHtml,
          className: "textMarkerDot " + shadowClass,
          // iconSize: 30,
          iconAnchor: [3.5, 3.5],
        });
        return myIcon;
      }
    },
    //根据指标值获取指标等级，包括零值，如果没有分级别准直接用1级
    getLevel(value,stationType) {

      let that = this;
      let result = "1";
debugger;
      let pieceStandard = that.channelLevelStandard[stationType].filter((e) => {
        return e.ChannelMap == that.channelMap;
      });
      if (pieceStandard.length > 0) {
        let channelStandard = pieceStandard[0];
        switch (channelStandard.Compare) {
          case "=":
            result =
              value < channelStandard.Level1 || value > channelStandard.Level5
                ? "6"
                : "1";
            break;
          case "≥":
            if (value >= channelStandard.Level1) {
              result = "1";
            }
            if (
              value < channelStandard.Level1 &&
              value >= channelStandard.Level2
            ) {
              result = "2";
            }
            if (
              value < channelStandard.Level2 &&
              value >= channelStandard.Level3
            ) {
              result = "3";
            }
            if (
              value < channelStandard.Level3 &&
              value >= channelStandard.Level4
            ) {
              result = "4";
            }
            if (
              value < channelStandard.Level4 &&
              value >= channelStandard.Level5
            ) {
              result = "5";
            }
            if (value < channelStandard.Level5) {
              result = "6";
            }
            break;
          case "≤":
            if (value <= channelStandard.Level1) {
              result = "1";
            }
            if (
              value > channelStandard.Level1 &&
              value <= channelStandard.Level2
            ) {
              result = "2";
            }
            if (
              value > channelStandard.Level2 &&
              value <= channelStandard.Level3
            ) {
              result = "3";
            }
            if (
              value > channelStandard.Level3 &&
              value <= channelStandard.Level4
            ) {
              result = "4";
            }
            if (
              value > channelStandard.Level4 &&
              value <= channelStandard.Level5
            ) {
              result = "5";
            }
            if (value > channelStandard.Level5) {
              result = "6";
            }
            break;
          default:
            break;
        }
      } else {
        if (value) {
          result = "7";
        } else {
          result = "0";
        }
      }
      return result;
    },
    markerOver(e) {
      let that = this;
      let stationType = e.sourceTarget.options.extData["StationType"];
      let tooltipStr = "";
      if (stationType == "河流" || stationType == "淀区") {
        let value = e.sourceTarget.options.extData[that.channelMap];
        tooltipStr =
          "<div>断面名称：" +
          e.sourceTarget.options.extData.StationName +
          "</div>" +
          "<p>数据时间：" +
          (e.sourceTarget.options.extData.Year == null
            ? "--"
            : e.sourceTarget.options.extData.Year) +
          "</p><p>" +
          that.channelName +
          "：" +
          (value || value === 0
            ? that.channelMap == "WaterLevel"
              ? that.getLevelStr(value)
              : value
            : "--") +
          "</p>";
      } else {
        tooltipStr =
          "<div>单位名称：" +
          e.sourceTarget.options.extData.SewageName +
          "</div>" +
          "<p>详细地址：" +
          e.sourceTarget.options.extData.SewageAddress +
          "</p>";
      }
      let curZoomIndex = that.map.getZoom();
      let offset = [0, 0];
      if (curZoomIndex > 14) {
        offset = [0, -12.5];
      } else if (curZoomIndex >= 12) {
        offset = [0, -12];
      } else if (curZoomIndex < 12 && curZoomIndex >= 10) {
        offset = [0, -9];
      } else if (curZoomIndex < 10) {
        offset = [0, -3.5];
      }
      e.sourceTarget
        .bindTooltip(tooltipStr, {
          direction: "top",
          offset: offset,
          className: "my-map-tooltip",
        })
        .openTooltip(e.sourceTarget.getLatLng());
    },
    //marker的点击事件，回传参数为marker，与marker中站点的实时数据（包括站点基本信息）
    markerClick(e) {
      if (this.$listeners["marker-click"]) {
        this.$emit(
          "marker-click",
          e.sourceTarget,
          e.sourceTarget.options.extData
        );
      }
    },
    //重置视图到初始位置
    resetView() {
      this.fly(39.1, 115.702331, 8.5);
    },
    //地图定位到某个坐标
    fly(lat, lon, zoomIndex) {
      var tooltipStr = "<div>断面名称</div>";
      this.map.flyTo([lat, lon], zoomIndex);
      /* this.Curtooltip = this.map.openTooltip(tooltipStr, [lat, lon], {
        direction: "top",
        offset: [0, -10],
        className: "my-map-tooltip",
      }); */
    },
    flyRiver(riverName, zoomIndex) {
      let river = this.riverLatLngs.find((x) => x.name == riverName);

      if(river)
        this.map.flyTo([river.latlng[1], river.latlng[0]], zoomIndex);
        else
        this.$message.error("定位失败");
    },

    startMeasureLine() {
      measureTool.startMeasureLine(this.map);
    },
    startMeasureArea() {
      measureTool.startMeasureArea(this.map);
    },
    clearMap() {
      measureTool.clearMap(this.map);
    },
    getChannelLevelData() {
      let that = this;
      that.$api.get(
        "/Map/GetChannelLevelData",
        null,
        function (res) {
          if (res.code == 200) {
            that.channelLevelStandard = res.data;
          }
        }
      );
    },
    //清除厂界，传输，园区，污染源的markerGroup
    clearMarkerGroup() {
      if (this.markerGroup.hl != null) {
        this.markerGroup.hl.clearLayers();
      }
      if (this.markerGroup.dq != null) {
        this.markerGroup.dq.clearLayers();
      }
      /* if (this.markerGroup.ws != null) {
        this.markerGroup.ws.clearLayers();
      } */
    },
  },
  mounted() {
    this.initMap();
    this.getChannelLevelData();
  },
  watch: {
    mapChangeIndex() {
      this.clearMarkerGroup();
      this.setStationMarker();
    },
  },
};
</script>
<style lang="less">
// .leaflet-zoom-animated img {
//   -webkit-filter: invert(50%) grayscale(0) saturate(0.5) brightness(1.6)
//     opacity(1) hue-rotate(334deg) sepia(10%) !important;
//   -ms-filter: invert(1) grayscale(0) saturate(0.5) brightness(1.6) opacity(1)
//     hue-rotate(334deg) sepia(10%) !important;
//   -moz-filter: invert(1) grayscale(0) saturate(0.5) brightness(1.6) opacity(1)
//     hue-rotate(334deg) sepia(10%) !important;
//   filter: invert(1) grayscale(0) saturate(0.5) brightness(1.6) opacity(1)
//     hue-rotate(334deg) sepia(1%) !important;
// }
.my-map-tooltip {
  border: none;
  box-sizing: border-box;
  padding: 8px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
}
.my-map-tooltip::before {
  border-top-color: rgba(0, 0, 0, 0.5);
}
</style>
<style lang="less" scoped>
.main {
  position: relative;
  padding: 0;
  margin: 0;
  font-family: "Microsoft yahei";
  height: 100%;
  min-height: 100%;
  font-size: 0.128vw;
  min-width: 1024px;
  color: #fff;
  overflow: hidden;
  background-color: #00192f;
}
</style>
<style>
.textMarker {
  height: 20px !important;
  width: 45px !important;
  padding: 2px;
  border-radius: 4px;
  background-color: #fff;
}
.textMarkerDot {
  height: 7px !important;
  width: 7px !important;
  border-radius: 50%;
}
.text-marker-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-weight: bold;
}
@keyframes shineRed {
  from {
    -webkit-box-shadow: 0 0 5px #ffec3d;
    opacity: 1;
  }
  50% {
    -webkit-box-shadow: 0 0 20px #ffec3d;
    opacity: 1;
  }
  to {
    -webkit-box-shadow: 0 0 30px #ffec3d;
    opacity: 1;
  }
}
.shine_red {
  animation: shineRed 2s infinite;
  border-radius: 50%;
}
.map-marker-level0 {
  background: #acacac;
}
.map-marker-level1 {
  background-color: #3cc7f5;
}
.map-marker-level2 {
  background: #11abf1;
  color: #000;
}
.map-marker-level3 {
  background: #5dd420;
}
.map-marker-level4 {
  background: #ffc000;
}
.map-marker-level5 {
  background: #fd8200;
}
.map-marker-level6 {
  background: #fd3c00;
}
.map-marker-level7 {
  background: #3cc7f5;
}
.map-marker-shadow-level0 {
  box-shadow: 0 0 7px 2px #acacac;
}
.map-marker-shadow-level1 {
  box-shadow: 0 0 7px 2px #3cc7f5;
}
.map-marker-shadow-level2 {
  box-shadow: 0 0 7px 2px #11abf1;
}
.map-marker-shadow-level3 {
  box-shadow: 0 0 7px 2px #5dd420;
}
.map-marker-shadow-level4 {
  box-shadow: 0 0 7px 2px #ffc000;
}
.map-marker-shadow-level5 {
  box-shadow: 0 0 7px 2px #fd8200;
}
.map-marker-shadow-level6 {
  box-shadow: 0 0 7px 2px #fd3c00;
}
.map-marker-shadow-level7 {
  box-shadow: 0 0 7px 2px #3cc7f5;
}
</style>